var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "9px",
    viewBox: "0 0 10 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B63D47C0-8CCD-4C71-8480-A3F62AD88DB1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-Center--Archived-Messages",
    transform: "translate(-511.000000, -236.000000)",
    fill: "#D6CBFF",
    stroke: "#9E84EE",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(511.848843, 236.780224)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.25,
    y: 0.25,
    width: 8.2400654,
    height: 1.1074851,
    rx: 0.553742548
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88891054,1.8574851 L7.88891054,6.17885943 C7.88891054,6.5302506 7.74648113,6.8483756 7.51620392,7.07865281 C7.31882346,7.27603327 7.05690176,7.4088725 6.76481092,7.44279839 L6.61641054,7.45135943 L2.12365485,7.45135943 C1.77226368,7.45135943 1.45413868,7.30893002 1.22386148,7.07865281 C1.02648101,6.88127235 0.893641785,6.61935065 0.859715892,6.32725981 L0.851154854,6.17885943 L0.851154854,1.8574851 L7.88891054,1.8574851 Z M5.79437631,2.95856272 L2.94568908,4.10987489 L5.90379607,3.44644315 L5.79437631,2.95856272 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.8d3377b646a151029abebe59afd622e4.svg";
export { ForwardRef as ReactComponent };